import { render, staticRenderFns } from "./ComboEdit.vue?vue&type=template&id=2355d81e&scoped=true"
import script from "./ComboEdit.vue?vue&type=script&lang=js"
export * from "./ComboEdit.vue?vue&type=script&lang=js"
import style0 from "./ComboEdit.vue?vue&type=style&index=0&id=2355d81e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2355d81e",
  null
  
)

export default component.exports